"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _dataDisplay = require("./data-display");
Object.keys(_dataDisplay).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dataDisplay[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dataDisplay[key];
    }
  });
});
var _dataEntry = require("./data-entry");
Object.keys(_dataEntry).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dataEntry[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dataEntry[key];
    }
  });
});
var _feedback = require("./feedback");
Object.keys(_feedback).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _feedback[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _feedback[key];
    }
  });
});
var _layout = require("./layout");
Object.keys(_layout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _layout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _layout[key];
    }
  });
});
var _navigation = require("./navigation");
Object.keys(_navigation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _navigation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _navigation[key];
    }
  });
});
var _overlay = require("./overlay");
Object.keys(_overlay).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _overlay[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _overlay[key];
    }
  });
});